import React from 'react';  
import './NewPost.css';  

class Popup extends React.Component {  
render() {  
return (  
<div className='popup'>  
<div className='popup\_inner'>  
{this.props.formSubmit} 
<button onClick={this.props.closePopup}>close me</button>  
</div>  
</div>  
);  
}  
}  

export default Popup;